module.exports = __webpack_public_path__ + "static/simufact1-bacab15477a7e9c47bd74140eb7b8dae.png";